var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{domProps:{"innerHTML":_vm._s(_vm.$t('welcome.text'))}}),_c('b-form-group',{staticClass:"mt-5"},[_c('b-button',{staticClass:"float-right",on:{"click":_vm.nextHandler}},[_vm._v(_vm._s(_vm.$t("welcome.next")))])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }